import { Box, Grid, Tab, Tabs, styled } from "@mui/material";

import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import BasketSelect from "./BasketSelect";
import BrokerSelect from "./BrokerSelect";
import TradeWalletAction from "pages/BasicTrade/components/TradeWalletAction";

function TradeTypeTabs() {
  const tradeInsertForm = useSelector((state) => state.trade.tradeInsertForm?.data);

  const [searchParams, setSearchParams] = useSearchParams();
  const tradeTypeId = +searchParams.get("tradeTypeId") || 1;

  const handleChange = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    setSearchParams({ ...allSearchParams, tradeTypeId: newValue });
  };

  return (
    <Wrapper container alignItems="flex-end" ml={1}>
      <Grid item xs={6}>
        <BasketSelect />

        <BrokerSelect />
      </Grid>

      <Grid item xs={6} textAlign="right">
        <TradeWalletActionWrapper>
          <TradeWalletAction />
        </TradeWalletActionWrapper>

        <TabsStyle value={tradeTypeId} onChange={handleChange}>
          {tradeInsertForm?.lisTradeType?.map((wallet, index) => (
            <Tab label={wallet?.name} value={wallet?.id} key={index} />
          ))}
        </TabsStyle>
      </Grid>
    </Wrapper>
  );
}

const Wrapper = styled(Grid)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginBottom: theme.spacing(3),
}));

const TabsStyle = styled(Tabs)(({ theme }) => ({
  '.MuiTabs-flexContainer': {
    justifyContent: 'flex-end'
  }
}));

const TradeWalletActionWrapper = styled(Box)(({ theme }) => ({
  ".MuiBox-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",

    ".MuiButtonBase-root": {
      marginLeft: theme.spacing(1),
      padding: 0
    },
  },
}));

export default TradeTypeTabs;
